import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/philipp2.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series II, volume 1 (2nd edition)</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		p 767<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: early December 1679<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (99k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Christian Philipp (early December 1679)</title>
            <meta name="description" content="An English translation of a LETTER TO CHRISTIAN PHILIPP by Gottfried Wilhelm Leibniz, from early December 1679" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>CHRISTIAN PHILIPP TO LEIBNIZ</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A II 1, p766</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I remember, Sir, when we were at Mr Pufendorf's house once, that you stated quite firmly that Mr Descartes' principles lead to atheism. But as I no longer remember the steps of this argument, I implore you to be kind enough to refresh my memory of them.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- 22 November/2 December 1679.<br /><br /><br />
                <center><h2>LEIBNIZ TO CHRISTIAN PHILIPP</h2>
                        </center>
                        <br />
                        [<b>A II 1, p767</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Extract from one of my letters to Mr Philipp<br /><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;As for Descartes' philosophy, about which you ask my opinion, I am wary of saying absolutely that it leads to atheism. It is true that I, who have studied him attentively, am very suspicious of some of things he says. For example, the two passages that say that the final cause should not be considered in physics<a name="1" href="#note1"><sup>1</sup></a> and that matter successively takes on all the forms of which it is capable.<a name="2" href="#note2"><sup>2</sup></a> There is an admirable passage in Plato's <var>Phaedo</var> which rightly criticizes Anaxagoras for the same thing which displeases me in Mr Descartes.<a name="3" href="#note3"><sup>3</sup></a> For my part, I believe that the laws of mechanics which serve as foundation for the whole system depend on final causes, that is, on the will of God determined to do what is most perfect, and that matter does not take on all possible forms but only the most perfect ones. Otherwise we would have to say that there will be a time in which everything will be badly ordered, which is far removed from the perfection of the author of things. Aside from that, if Descartes had been less given to his imaginary hypotheses and if he had been more attached to experience, I think his physics would have been worth following, since it must be admitted that he had great penetration. As for his geometry and analysis, they are far from being as perfect as is claimed by those who have only concerned themselves with investigating minor problems. There are several errors in his metaphysics, and he did not know the genuine source of truths or this general analysis of concepts which, in my opinion, Jung understood better than he did.<a name="4" href="#note4"><sup>4</sup></a> I admit, however, that it is very useful and instructive to read Descartes, and without question I prefer to deal with a Cartesian than with a man from another school. In a word, I consider this philosophy as the antechamber of the true philosophy.<a name="5" href="#note5"><sup>5</sup></a>
                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />
                        NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> Descartes, <var>Principles of Philosophy</var> I.28 and III.2.<br />
                        <a name="note2" href="#2">2.</a> Descartes, <var>Principles of Philosophy</var> III.47.<br />
                        <a name="note3" href="#3">3.</a> Plato, <var>Phaedo</var> 97b9-99d1.<br />
                        <a name="note4" href="#4">4.</a> Leibniz is referring here to Joachim Jung (1587-1657).<br />
                        <a name="note5" href="#5">5.</a> On this point, see Leibniz's short piece 'Cartesianism, The Antechamber Of The True Philosophy' (1677?), an English translation of which is available <Link to="/cartesianism" target='_blank'>here</Link>.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2007
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
